import Image from 'next/image';
import { BorderWrapper } from './styles';

const SmartInvestment = (): JSX.Element => {
  return (
    <BorderWrapper>
      <div className="text-center">
        <h3 className="text-s-40 sm:text-s-20">
          Make a Smart Investment choice:
        </h3>
      </div>
      <div className="flex flex-wrap mt-6 justify-items-center">
        <div className="w-1/2 p-6 sm:p-2 sm:w-full">
          <div className="text-center">
            <a href="https://cleartax.in/save/plan/19?ref=ifsc-cta-save-tax">
              <Image
                alt="save tax"
                height="350"
                width="350"
                src="https://assets1.cleartax-cdn.com/cleartax/images/1582627200_savetax.svg"
              />
              <button className="btn btn-blue mt-6 sm:mt-2 sm:mb-6 w-full">
                I Want To Save Tax
              </button>
            </a>
          </div>
        </div>

        <div className="w-1/2 p-6 sm:p-2 sm:w-full">
          <div className="text-center">
            <a href="https://cleartax.in/save/plan/22?ref=ifsc-cta-grow-wealth">
              <Image
                alt="save tax"
                height="350"
                width="350"
                src="https://assets1.cleartax-cdn.com/cleartax/images/1582627222_growwealth.svg"
              />
              <button className="btn btn-blue mt-6 w-full sm:mt-2">
                I Want To Grow Wealth
              </button>
            </a>
          </div>
        </div>
      </div>
    </BorderWrapper>
  );
};

export default SmartInvestment;
